import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { goTo } from '@adornis/router/client/open-href.js';
import '@chancenwerk/design/components/cr-button.js';
import '@chancenwerk/design/components/cr-flex.js';
import '@chancenwerk/design/components/cr-sidebar.js';
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

/**
 * @customElement logistik-component-base-header
 */
@customElement('logistik-component-base-header')
export class LogistikComponentBaseHeader extends ChemistryLitElement {
  @property({ type: String, reflect: true }) pageTitle = '';
  @property({ type: String, reflect: true }) pageDescription = '';
  @property({ type: String, reflect: true }) backRoute = '';

  @state() size = new WindowSizeController(this);

  override render() {
    return html`
      <cr-flex space="lg">
        <cr-flex
          horizontal
          crossaxis-center
          ${css(
            this.backRoute ? { marginLeft: window.outerWidth <= 1430 ? '0' : `calc(-${this.spacing.md} - 25px)` } : {},
          )}
          space="md"
        >
          ${this.backRoute
            ? html` <cr-button mode="icon" icon="arrow_back_ios" @click=${() => goTo(this.backRoute)}> </cr-button> `
            : nothing}
          <cr-flex crossaxis-center space-between horizontal flex>
            <cr-h2>${this.pageTitle}</cr-h2>
            <slot></slot>
          </cr-flex>
        </cr-flex>
        ${this.pageDescription && html` <cr-text> ${this.pageDescription} </cr-text>`}
      </cr-flex>
    `;
  }
}
